// Page-title resolution for the institution top command bar. These maps used to
// live inside the shell's topbar component; they are lifted here so the shared
// TopCommandBar receives a plain string and the mapping stays unit-testable.

const SECTION_TITLES: Record<string, string> = {
  pending: 'Pending actions',
  programs: 'Programs',
  participants: 'Participants',
  'record-templates': 'Record templates',
  'publish-center': 'Submission intake',
  'review-queue': 'Review queue',
  'issue-records': 'Issue records',
  'public-trust-pages': 'Public trust pages',
  'audit-trail': 'Audit trail',
  'heritage-archive': 'Institutional archive',
  people: 'Team & permissions',
};

const ROUTE_TITLES: Record<string, string> = {
  '/institution-dashboard': 'Institution overview',
  '/institution-dashboard/heritage-archive': 'Institutional archive',
  '/institution-dashboard/stories': 'Community stories',
  '/institution-dashboard/community-stories': 'Community stories',
  '/institution-dashboard/proof-cards': 'Sharing & proof',
  '/institution-dashboard/followers': 'Trusted network',
  '/institution-dashboard/trusted-network': 'Trusted network',
  '/institution-dashboard/analytics': 'Reports',
  '/institution-dashboard/settings': 'Settings',
  '/institution-dashboard/billing': 'Billing',
  '/institution-dashboard/support': 'Help & feedback',
  '/institution-dashboard/notifications': 'Notifications',
  '/institution-dashboard/partnerships': 'Partnerships & collaboration',
  '/institution-dashboard/partner-programs': 'Pilot programs',
  '/institution-dashboard/procurement': 'Procurement & readiness',
};

export function resolveInstitutionPageTitle(pathname: string, section: string | null): string {
  return (section && SECTION_TITLES[section]) || ROUTE_TITLES[pathname] || 'Institution workspace';
}
